import { render, staticRenderFns } from "./TheSlider.vue?vue&type=template&id=c8a17c70&scoped=true&"
var script = {}
import style0 from "./TheSlider.vue?vue&type=style&index=0&id=c8a17c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a17c70",
  null
  
)

export default component.exports